<template>
  <div id="user-list">
    <template-email-add-new
      v-model="isAddNewTemplateSidebarActive"
      @refetch-data="getTemplateEmail"
    />

    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getTemplateEmail"
        />

        <v-spacer />

        <v-btn
          color="success"
          class="mb-4 px-4"
          @click.stop="isAddNewTemplateSidebarActive = !isAddNewTemplateSidebarActive"
        >
          <v-icon
            left
            size="25"
            class="mr-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Criar Template</span>
        </v-btn>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />

          <table-template-email
            :items="templates"
            :headers="headers"
            @confirmar-ativacao-inativacao="getTemplateEmail"
          />
        </div>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { mdiAccount, mdiPlus } from '@mdi/js'
import Contadores from '@/components/contadores/Contadores.vue'
import TableTemplateEmail from '@/components/tables/TableTemplateEmail.vue'
import TemplateEmailAddNew from './TemplateEmailAddNew.vue'
import TemplateEmailService from '@/services/modules/TemplateEmailService'

export default {
  components: {
    Contadores,
    TableTemplateEmail,
    TemplateEmailAddNew,
  },

  setup() {
    const isAddNewTemplateSidebarActive = ref(false)
    const loading = ref(true)
    const search = ref('')
    const templates = ref([])
    const filtroStatus = ref('')
    const contadores = ref({
      total: 0,
      ativos: 0,
      inativos: 0,
    })

    async function getTemplateEmail() {
      try {
        templates.value = await TemplateEmailService.get()

        contadores.value.total = templates.value.length
        contadores.value.ativos = templates.value.filter(ativo => ativo.ativo).length
        contadores.value.inativos = templates.value.filter(ativo => !ativo.ativo).length

        if (search.value) {
          templates.value = templates.value.filter(t => t.nome.toLowerCase().includes(search.value.toLowerCase()))
        }
        if (filtroStatus.value) {
          templates.value = templates.value.filter(t => t.ativo === filtroStatus.value || t.ativo.toString() === filtroStatus.value)
        }

        templates.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))
        setTimeout(() => {
          loading.value = false
          isAddNewTemplateSidebarActive.value = false
        }, 1000)
      } catch {
        loading.value = false
      }
    }

    function atualizarFiltro(item) {
      filtroStatus.value = item
      getTemplateEmail()
    }

    onMounted(getTemplateEmail)

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRIÇÃO', value: 'descricao' },
      { text: 'STATUS', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    const opcoes = [
      { title: 'Inativos', value: 'false' },
      { title: 'Ativos', value: 'true' },
      { title: 'Todos', value: '' },
    ]

    return {
      atualizarFiltro,
      getTemplateEmail,
      isAddNewTemplateSidebarActive,
      templates,
      loading,
      search,
      opcoes,
      headers,
      contadores,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>
